module.exports = __webpack_public_path__ + "static/media/shopify.08b97152.svg";